import { Button, Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { Spacing, SpacingRow, SpacingUnit } from 'components/ui';
import { useEditFormStore } from 'stores/local';

import s from './RequiredFieldWarning.module.scss';

const RequiredFieldWarning: React.FC = () => {
  const { t } = useTranslation();
  const { editFormStore } = useEditFormStore();

  const handleCustomFieldAdd = React.useCallback(() => {
    editFormStore.formStore.handleCustomFieldAdd();
  }, [editFormStore.formStore]);

  return (
    <Spacing spacing={SpacingUnit.unit4} className={s.warning}>
      <Typography.Text type="secondary">
        {t('editForm.requiredFieldsNotification')}
      </Typography.Text>
      <SpacingRow hSpacing={SpacingUnit.unit2}>
        <Button onClick={handleCustomFieldAdd} size="middle">
          {t('editForm.createOwnField')}
        </Button>
        <Button
          onClick={editFormStore.catalogDrawerControllerStore.open}
          size="middle"
          type="primary"
        >
          {t('editForm.addFieldFromCatalog')}
        </Button>
      </SpacingRow>
    </Spacing>
  );
};

export default observer(RequiredFieldWarning);
